// libs
import { styled } from '@nykaa/ui-components';

export const CopyCodeWrapper = styled.div`
  display: block;
  width: fit-content;
  .copycode-container {
    display: flex;
    align-items: center;
  }
  ${({ theme }) =>
    `background: ${theme.colors.surface20}; 
  padding: ${theme.spacing.spacing10} ${theme.spacing.spacing20};
  margin-top: ${theme.spacing.spacing20};
  border-radius: ${theme.borders.radius10};`};

  svg {
    ${({ theme }) =>
      `margin-left: ${theme.spacing.spacing10};
      `};
  }
`;
